<div>
    <span class="sp-icon icon-arrow-left back-btn small" (click)="toggleShowCustom($event)"> </span>
    <label class="mb-10 small">{{ "control_custom_color" | translate }}</label>

    @if (!hideGradient) {
        <div class="mb-10">
            <select
                class="form-control input-sm"
                [ngModel]="colorPickerType"
                (ngModelChange)="setColorPickerType($event)"
            >
                <option [value]="EColorPickerTypes.solid">
                    {{ "control_color_solid" | translate }}
                </option>
                <option [value]="EColorPickerTypes.gradient">
                    {{ "control_color_gradient" | translate }}
                </option>
            </select>
        </div>
    }

    @if (gradientObject) {
        <div class="cp-preset-colors-class preset-gradient-bg" [style.background]="colorValue">
            @for (value of gradientObject.values; track $index; let i = $index) {
                <div class="presets-wrapper">
                    <div
                        class="preset-color"
                        [class.selected]="i === gradientValueIndex"
                        (click)="setGradientValueIndex(i)"
                        [style.background]="value.color"
                    ></div>
                </div>
            }
        </div>
    }

    @if (!gradientObject) {
        <span
            #ignoredInput
            [cpIgnoredElements]="[ignoredInput]"
            [cpToggle]="true"
            [(colorPicker)]="colorValue"
            cpOutputFormat="rgba"
            cpDialogDisplay="inline"
            cpWidth="160px"
        ></span>
    }
    @if (gradientObject) {
        <span
            #ignoredInputGradient
            [cpIgnoredElements]="[ignoredInputGradient]"
            [cpToggle]="true"
            [colorPicker]="gradientObject.values[gradientValueIndex].color"
            (colorPickerChange)="setGradientColor($event)"
            cpOutputFormat="rgba"
            cpDialogDisplay="inline"
            cpWidth="160px"
        ></span>
    }

    @if (!gradientObject) {
        <div class="alpha-control">
            <sp-input-num
                [small]="true"
                [prefixImgUrl]="'./assets/img/transparent-icon/lg-opacity-icon.svg'"
                suffixText="%"
                [min]="0"
                [max]="100"
                [value]="getAlphaFromRgba(colorValue)"
                (valueChange)="setAlpha($event)"
            />
        </div>
    }

    @if (gradientObject) {
        <div class="alpha-control">
            <sp-input-num
                [small]="true"
                [prefixImgUrl]="'./assets/img/transparent-icon/lg-opacity-icon.svg'"
                suffixText="%"
                [min]="0"
                [max]="100"
                [value]="getAlphaFromRgba(gradientObject.values[gradientValueIndex].color)"
                (valueChange)="setAlphaGradientItem($event)"
            />
        </div>
    }

    <div class="spc-color-picker-button">
        <input
            type="text"
            [class.error-inp]="formColor.invalid"
            [ngModel]="colorValue | rgbaToHex"
            (ngModelChange)="changeColorHandler($event)"
            maxlength="7"
            class="spc-color-picker-button-name form-control"
        />
        <span class="spc-color-picker-button-area" [style.background]="colorValue">
            <sp-transparent-icon [color]="colorPickerType === EColorPickerTypes.solid ? colorValue : gradientColor" />
        </span>
    </div>
</div>
